const initialState = {
    ajioWalletBalanceDetails: {},
    success: false,
    failure: false
  };

const ajioWalletDataBottomStrip = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_AJIOWALLET_DATA_BOTTOMSTRIP':
        return { ...state, ajioWalletBalanceDetails: action?.payload?.ajioWalletData };
      case 'GET_AJIOWALLET_DATA_SUCCESS_BOTTOMSTRIP':
        return { ...state, success: true, failure: false };
      case 'GET_AJIOWALLET_DATA_FAIL_BOTTOMSTRIP':
        return { ...state, success: false , failure: true };
        default:
            return state;
    }
}

export default ajioWalletDataBottomStrip;  